import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "@/pages/Home";
import { trackEvent } from "@/services/analyticsService";

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view", { path: location.pathname });
  }, [location.pathname]);

  return null;
}

export default function AppRouter() {
  return (
    <>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </>
  );
}
